// extracted by mini-css-extract-plugin
module.exports = {"main":"OicQ53zTNxtbgbuPsEIv","wizard":"IrjqQSJ7rpJwUCAwRrx1"};